import "@/scripts/helpers/polyfills";
import "@/scripts/signnowHeader";
import "@/modules/layout/page-header/page-header-search";
import "@/modules/search/search-on-site";
import MainFooter from "@/modules/layout/page-footer/index";
// import Offcanvas from "@/modules/layout/offcanvas/offcanvas";
import BannerHeader from "@/modules/banners/banner-header/index";
import BannerMarketing from "@/modules/banners/banner-marketing/index";
import DonateBanner from "@/modules/banners/donate-banner/index";
import CookiePopup from "@/modules/containers/popup/cookie";
import { getUrlParams, getDomainName } from "@/scripts/helpers/getUrlParams";
import GoogleOneTap from "@/modules/containers/google-one-tap/index";
import alternativeDriftChat from "@/modules/experiments/drift-chat/index";
import { stopStickyElement } from "@/scripts/helpers/stopStickyElement";
import appBanner from "@/modules/banners/app-banner/index";
import { emailToCookieHandler } from "@/scripts/experiments/exp-18042/index";

import {
  handleParsleyActions,
  initCustomSelectPlugin
} from "@/scripts/helpers/parsleyValidation";
import {
  attachIE11helper,
  attachEdgeBrowserHelper,
  attachSafariBrowser,
  attachFirefoxBrowser,
  bindJQuery
} from "@/scripts/helpers/library";
import Cookies from "js-cookie";

import { mainPageDestroyAnimation, keyFeatures, integrations, stopParallax } from '@/scripts/stopSlickAnimation';

bindJQuery();

$(document).ready(function() {
  // Offcanvas();
  // Modal();
  attachIE11helper();
  attachEdgeBrowserHelper();
  attachSafariBrowser();
  attachFirefoxBrowser();
  MainFooter();
  handleParsleyActions();
  initCustomSelectPlugin();
  BannerHeader();
  BannerMarketing();
  GoogleOneTap();
  // exp-mkt-16956
  appBanner();
  emailToCookieHandler();

  setTimeout(() => {
    CookiePopup();
    DonateBanner();
  }, 4000);

  setTimeout(() => {
    alternativeDriftChat();
  }, 2000);
});

const savePartnerCookie = (name, value, exp) => {
  const domain = getDomainName();
  Cookies.set(name, value, {
    expires: exp,
    domain: domain
  });
};

const gspk = getUrlParams("gspk");
const gsxid = getUrlParams("gsxid");
const irmpname = getUrlParams("irmpname");
const irclickid = getUrlParams("irclickid");

if (gspk && gsxid) {
  savePartnerCookie("SN_PARTNER_IDENTIFIER", gspk, 30);
  savePartnerCookie('SN_PARTNER_SESSION_ID', gsxid, 30);
  savePartnerCookie('SN_PARTNER_SOURCE', 'partner_stack', 30);
} else if (irmpname && irclickid) {
  savePartnerCookie("SN_PARTNER_IDENTIFIER", irmpname, 30);
  savePartnerCookie('SN_PARTNER_SESSION_ID', irclickid, 30);
  savePartnerCookie('SN_PARTNER_SOURCE', 'impact', 30);
}

$(window).resize(function() {
  if (window.innerWidth < 960) {
    $(".page-header--search .js-search-wrapper").removeClass("is-visible");
  }
});

window.destroyAnimationAQA = page => {
  stopStickyElement();

  if (page === "index") {
    mainPageDestroyAnimation();
  } else if (page === "key-features" || page === "document-generation") {
    keyFeatures();
  } else if (page === "integrations") {
    integrations();
  } else if (page === "parallax") {
    stopParallax();
  }
};
